import {NgModule} from '@angular/core';
import {PackagesListComponent} from './packages-list/packages-list.component';
import {SharedModule} from '@helpers/modules/shared.module';
import {WelcomeComponent} from './welcome/welcome.component';
import {PackagesListService} from './services/packages-list.service';
import {PackagesListResolverService} from './services/packages-list-resolver.service';
import {WizardModule} from './wizard/wizard.module';
import {PipesModule} from '@pipes/pipes.module';
import {DocumentsDownloadComponent} from './documents-download/documents-download.component';
import {WizardStatusComponent} from './wizard-status/wizard-status.component';
import {CustomAccordionModule} from '@components/custom-accordion/custom-accordion.module';
import {LaboratoryDocumentsListComponent} from './laboratory-documents-list/laboratory-documents-list.component';
import {LaboratoryDocumentsModule} from '@components/laboratory-documents/laboratory-documents.module';
import {LayoutModule} from '../../layout-components/layout.module';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {IconsModule} from '@lab365/icons';


@NgModule({
    imports: [
        SharedModule,

        /**
         * Хоть модуль визарда и подгружается как loadChildren, мы включим его в import,
         * чтобы chunk уже был подгружен даже на списке документов ЛНК и сам визард
         * из-за этого отрисовывался быстрее
         */
        WizardModule,
        PipesModule,
        LaboratoryDocumentsModule,
        LayoutModule,
        DirectivesModule,
        CustomAccordionModule,
        IconsModule,
    ],
    exports: [],
    declarations: [
        PackagesListComponent,
        WelcomeComponent,
        LaboratoryDocumentsListComponent,
        WelcomeComponent,
        DocumentsDownloadComponent,
        WizardStatusComponent,
    ],
    providers: [
        PackagesListService,
        PackagesListResolverService
    ],
})
export class PackagesModule {
}
